module.exports = __webpack_public_path__ + "img/ttxs-qrcode.e11664b3.png";